module.exports = __webpack_public_path__ + "static/media/moderation-meeting.cdf9bd1a.png";